/**
 * Determines the canonical admin URL for a given host.
 * Used to redirect users from the main app domain to the admin domain
 * when accessing admin routes.
 * 
 * Returns the full origin (e.g. "https://admin.supabank.xyz") or null if no redirect needed/known.
 */
export function getCanonicalAdminUrl(currentHost: string): string | null {
  const host = currentHost.toLowerCase();
  
  // Localhost - no redirect
  if (host.startsWith('localhost') || host.startsWith('127.0.0.1')) {
    return null;
  }

  // Production
  if (host === 'supabank.xyz') {
    return 'https://admin.supabank.xyz';
  }

  // Staging
  if (host === 'staging.supabank.xyz') {
    return 'https://admin.staging.supabank.xyz';
  }

  // Dynamic subdomains (e.g. preview builds)
  // If host is "foo.supabank.xyz", admin is "admin.foo.supabank.xyz"? 
  // OR "admin.supabank.xyz"? 
  // The legacy logic was: if host.endsWith('.supabank.xyz') -> targetHost = `admin.${host}`
  // This implies if I am on "feature-1.supabank.xyz", admin is "admin.feature-1.supabank.xyz".
  // This seems to support Vercel preview deployments where every branch has a URL.
  if (host.endsWith('.supabank.xyz') && !host.startsWith('admin.')) {
    return `https://admin.${host}`;
  }

  return null;
}
